import React, { useState, useEffect } from "react";
import logo from "../assets/Logo.png";
import back from "../assets/images/back1.jpg";
import { Card } from "@nextui-org/react";
import { useNavigate } from "react-router";

const SucessPage = () => {
  
  const [transId, setTransId] = useState(null);
  const [userData, setUserData] = useState(null); // state for user data
  const navigate = useNavigate();

  useEffect(() => {
    const transaction = JSON.parse(localStorage.getItem("transaction"));
    const data = JSON.parse(localStorage.getItem("userData"));
    setTransId(transaction?.transactionid);
    setUserData(data);
  }, []);

  return (
    <div
      className="flex items-center px-4 md:px-0 justify-center py-20 h-svh"
      style={{ backgroundImage: `url(${back})`, backgroundSize: "cover" }}
    >
      <Card className="p-8 w-full md:w-[65vw] overflow-y-scroll h-[90vh] md:h-auto md:overflow-auto flex flex-col justify-center items-center text-center">
        <img src={logo} alt="Logo" className="w-80" />
        <h1 className="text-[2.8rem] font-semibold mt-8">
          Your Transaction has been Successful.
        </h1>
        <span className="text-3xl font-medium mt-4 text-[#757575]">
          Thank You! {userData?.companyname || userData?.firstname}
        </span>
        <span className="text-3xl font-medium mt-4 text-[#757575]">
          Your IACF Membership ID is - {userData?.usercode || "NA"}
        </span>

              <p className="text-sm sm:text-base text-gray-600 italic">
                <span className="text-red-600">*</span> Subject to receipt of
                payment, review by IACF Membership Committee, and confirmation.
              </p>

        <p
          onClick={() => navigate("/login")}
          className="text-lg text-blue-600 cursor-pointer"
        >
          Click here to Login
        </p>
        {/* <span className="text-2xl font-medium mt-4 text-green-500">Your Transaction ID : {transId} </span> */}
      </Card>
    </div>
  );
};

export default SucessPage;
